export const messages = {
    "shared-link.footer.link.install": "Probeer {brandName} gratis",
    "shared-link.footer.link.mobile": "{brandName} voor mobiel",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Beschermde gegevens",
    "shared-link.password-dialog-box.message": "Geef het wachtwoord op om toegang te krijgen tot de gedeelde gegevens",
    "shared-link.password-dialog-box.hint.password": "Wachtwoord",
    "shared-link.password-dialog-box.message.invalid-password": "Het wachtwoord is onjuist",
    "shared-link.form.button.open": "Openen",
    "shared-link.page-not-found.title": "Pagina niet gevonden",
    "shared-link.page-not-found.message.main": "De pagina die u zoekt, is niet gevonden.",
    "shared-link.page-not-found.message.description": "De link is mogelijk verouderd of u hebt een verkeerd adres getypt.",
    "shared-link.page-not-found.message.error": "Foutcode: 404",
    "shared-link.restore-file.label.size": "Grootte",
    "shared-link.restore-file.button.restore": "Downloaden",
    "shared-link.links-table.column.name": "Naam",
    "shared-link.links-table.column.size": "Grootte",
    "shared-link.links-table.action.restore": "Downloaden",
    "shared-link.links-table.action.restore-all": "Alles downloaden",
    "shared-link.side-bar.selected.title:plural": "{count} items geselecteerd | {count} item geselecteerd | {count} items geselecteerd",
    "shared-link.links-table.label.size": "Grootte",
    "shared-link.links-table.message.empty-folder": "Deze map is leeg"
};
